<script>
const BADGE_TYPE_PRIMARY = 'primary'
const BADGE_TYPE_SECONDARY = 'secondary'
const BADGE_TYPE_SUCCESS = 'success'
const BADGE_TYPE_DANGER = 'danger'
const BADGE_TYPE_WARNING = 'warning'

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'primary',
      validator: (value) =>
        [BADGE_TYPE_PRIMARY, BADGE_TYPE_SECONDARY, BADGE_TYPE_SUCCESS, BADGE_TYPE_DANGER, BADGE_TYPE_WARNING].includes(
          value,
        ),
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    badgeClasses() {
      return {
        badge: true,
        'badge-primary': this.type === BADGE_TYPE_PRIMARY,
        'badge-secondary': this.type === BADGE_TYPE_SECONDARY,
        'badge-success': this.type === BADGE_TYPE_SUCCESS,
        'badge-danger': this.type === BADGE_TYPE_DANGER,
        'badge-warning': this.type === BADGE_TYPE_WARNING,
        'badge-pill': this.rounded === true,
      }
    },
  },
}
</script>
<template>
  <span :class="badgeClasses">
    <slot></slot>
  </span>
</template>
